import { IGuestToken } from '@core/interfaces/auth/guest-token.interface';
import { AAGUID } from '@interticket/core';

export class GuestToken implements IGuestToken {

  readonly accessToken: string;
  readonly userId: AAGUID;

  constructor(iGuestToken: IGuestToken) {
    this.accessToken = iGuestToken.accessToken;
    this.userId = iGuestToken.userId;
  }

}
